/* CloudSecurityParticipantBadge.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _11 = "._1kba1h6o._1kba1h6o{align-items:center}";
const _10 = "._if291txw._if291txw{display:flex}";
const _9 = "._w1ap1osq._w1ap1osq{width:100%}";
const _8 = "._kkk2n7od{all:unset}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// eslint-disable-next-line import/no-named-as-default

import React from 'react';
import RichTooltip from '../../primitives/RichTooltip';
import CloudSecurityParticipantIcon from '../CloudSecurityParticipantIcon';
import CloudSecurityParticipantTooltipV2 from './CloudSecurityParticipantTooltipV2';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _7 = "._1wyboqnp{font-size:.75rem}";
const _6 = "._k48pni7l{font-weight:600}";
const _5 = "._o5721q9c{white-space:nowrap}";
const _4 = "._1ccqt94y{word-spacing:1px}";
const _3 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _2 = "._18u0v77o{margin-left:var(--ds-space-025,2px)}";
const _ = "._1p1dangw{text-transform:uppercase}";
const BadgeText = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1p1dangw _18u0v77o _syaz1gjq _1ccqt94y _o5721q9c _k48pni7l _1wyboqnp", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BadgeText.displayName = 'BadgeText';
}
const BadgeContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _9, _10, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_kkk2n7od _w1ap1osq _if291txw _1kba1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BadgeContainer.displayName = 'BadgeContainer';
}
export const CloudSecurityParticipantIconColor = {
  primary: "var(--ds-icon-brand, #0C66E4)",
  secondary: "var(--ds-icon, #44546F)"
};
export const CLOUD_SECURITY_BADGE_LABEL = 'Cloud Security Participant';
export default function CloudSecurityParticipantBadge(_ref3) {
  let {
    className,
    showLabel,
    iconSize,
    iconColor
  } = _ref3;
  const badgeIconColor = iconColor ? iconColor : CloudSecurityParticipantIconColor.primary;
  if (!showLabel) {
    return /*#__PURE__*/_jsx(CloudSecurityParticipantIcon, {
      label: "",
      size: iconSize,
      primaryColor: badgeIconColor,
      testId: "cloud-security-participant-icon"
    });
  }
  const stopEventPropagation = e => e.stopPropagation();
  const link = 'https://www.atlassian.com/licensing/marketplace#what-is-the-marketplace-bug-bounty-program';
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(RichTooltip, {
      content: /*#__PURE__*/_jsx(CloudSecurityParticipantTooltipV2, {
        learnMoreLink: link
      }),
      children: /*#__PURE__*/_jsxs(BadgeContainer, {
        tabIndex: -1,
        className: className,
        onClick: stopEventPropagation,
        children: [/*#__PURE__*/_jsx(CloudSecurityParticipantIcon, {
          label: "",
          size: iconSize,
          primaryColor: badgeIconColor,
          testId: "cloud-security-participant-icon"
        }), /*#__PURE__*/_jsx(BadgeText, {
          children: CLOUD_SECURITY_BADGE_LABEL
        })]
      })
    })
  });
}